import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/error.tsx");
